'use strict';

var React = require('react');

var SvgRefundMajor = function SvgRefundMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0h11c.828 0 1.5.677 1.5 1.512v18.21a.2.2 0 0 1-.334.149l-1.664-1.515a.497.497 0 0 0-.67 0l-1.664 1.514a.497.497 0 0 1-.67 0l-1.663-1.514a.497.497 0 0 0-.67 0l-1.663 1.514a.497.497 0 0 1-.67 0l-1.664-1.514a.497.497 0 0 0-.67 0l-1.664 1.515a.2.2 0 0 1-.334-.15v-18.209c0-.835.672-1.512 1.5-1.512zm5.5 7.596h-1.585l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 1 0 1.414-1.414l-1.294-1.293h1.586c2.069 0 2.999 1.116 2.999 3a1 1 0 1 0 2 0c0-2.916-1.736-5-5-5z"
  }));
};

exports.SvgRefundMajor = SvgRefundMajor;
